import Svg, { SvgProps, G, Path, Mask } from "react-native-svg";

const SectionsIcon = (props: SvgProps) => (
  <Svg strokeWidth="2" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
    <Mask id="mask0_26700_27938" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
      <Path d="M0 1.90735e-06H32V32H0V1.90735e-06Z" fill="white" />
    </Mask>
    <G mask="url(#mask0_26700_27938)">
      <Path
        d="M3.14269 11.3323H0.46875V20.1465L7.33881 27.0165H13.3404L16.8378 30.5139H18.3321L19.6905 29.1555L18.8 28.265C19.0493 27.663 19.0678 27.6185 19.3171 27.0165H26.3011L28.8818 29.5973L30.0287 28.4504V27.1888L28.9494 26.1095C28.9493 25.4295 28.9492 25.0485 28.9491 24.3685L30.4141 22.9035V15.3356L31.5312 14.2185V12.4297L29.9051 10.8035L25.373 15.3356H23.1478L19.1993 11.3323H15.5972"
        stroke="black"
        stroke-miterlimit="10"
      />
    </G>
    <Path
      d="M9.3125 12.677C7.10703 12.677 5.3125 10.8825 5.3125 8.677C5.3125 6.47154 7.10703 4.677 9.3125 4.677C11.518 4.677 13.3125 6.47154 13.3125 8.677C13.3125 10.8825 11.518 12.677 9.3125 12.677Z"
      stroke="black"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <Path d="M10.1133 17.5312H8.51328" stroke="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <Path d="M7.71211 17.5312H10.9121" stroke="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <Path
      d="M9.31289 17.5312C9.31289 14.3313 6.91289 12.6779 6.91289 12.6779H11.7129"
      stroke="black"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <Path
      d="M11.7125 12.6779C11.7125 12.6779 9.3125 14.3313 9.3125 17.5312"
      stroke="black"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <Path
      d="M7.99534 6.79445C8.15155 6.95067 8.15155 7.20392 7.99534 7.36013C7.83913 7.51635 7.58587 7.51635 7.42966 7.36013C7.27345 7.20392 7.27345 6.95067 7.42966 6.79445C7.58587 6.63824 7.83913 6.63824 7.99534 6.79445Z"
      fill="black"
    />
    <Path
      d="M9.59573 7.5945C9.75194 7.75072 9.75194 8.00397 9.59573 8.16018C9.43952 8.3164 9.18626 8.3164 9.03005 8.16018C8.87384 8.00397 8.87384 7.75072 9.03005 7.5945C9.18626 7.43829 9.43952 7.43829 9.59573 7.5945Z"
      fill="black"
    />
    <Path
      d="M8.79456 9.19485C8.95077 9.35106 8.95077 9.60431 8.79456 9.76053C8.63834 9.91674 8.38509 9.91674 8.22888 9.76053C8.07266 9.60431 8.07266 9.35106 8.22888 9.19485C8.38509 9.03863 8.63834 9.03863 8.79456 9.19485Z"
      fill="black"
    />
    <Path
      d="M7.31328 8.67764C7.31328 8.89854 7.13419 9.07764 6.91328 9.07764C6.69238 9.07764 6.51328 8.89854 6.51328 8.67764C6.51328 8.45673 6.69238 8.27764 6.91328 8.27764C7.13419 8.27764 7.31328 8.45673 7.31328 8.67764Z"
      fill="black"
    />
  </Svg>
);
export default SectionsIcon;
